/**
 * @flow
 */

import React from 'react';
import { Form } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

import CartItemFields from './CartItemFields';
import TotalPrice from './TotalPrice';

type CartItemsProps = {
    fields: Array<Object>,
    paid: boolean,
    append: Function,
    remove: Function,
};

function CartItems({ fields, paid, append, remove }: CartItemsProps) {
    return (
        <div>
            {fields.map((fieldItem, idx) => (
                <Form.Field key={fieldItem.id}>
                    <CartItemFields
                        index={idx}
                        onRemove={() => remove(idx)}
                        paid={paid}
                    />
                </Form.Field>
            ))}
            {!paid && (
                <a
                    href="#add"
                    onClick={e => {
                        e.preventDefault();
                        append({
                            entity: null,
                            quantity: null,
                            price: null,
                            paymentType: null,
                        });
                    }}
                >
                    +{' '}
                    <FormattedMessage
                        id="pages.appointments.cart.form.addItem"
                        defaultMessage="Add item"
                    />
                </a>
            )}
            <TotalPrice />
        </div>
    );
}

export default CartItems;
